import { useEffect, useState } from 'react';
import { checkUserInfo } from '@miro-site/core';

function useUser() {
  var _useState = useState({
    isLoggedIn: true
  }),
      user = _useState[0],
      setUser = _useState[1];

  useEffect(function () {
    var _ref = checkUserInfo() || {},
        _ref$id = _ref.id,
        userId = _ref$id === void 0 ? 0 : _ref$id;

    setUser({
      isLoggedIn: userId !== undefined && userId > 0
    });
  }, []);
  return user;
}

export default useUser;